import { getCurrencySymbol } from '@angular/common';
import { Injectable } from '@angular/core';

import { CurrencyConfig } from '@frontend/sports/common/client-config-data-access';
import { UserService } from '@frontend/sports/user/feature';

@Injectable()
export class ErrorMessageCurrencySymbolFormatService {
    private readonly isCurrencySymbolEnabled: boolean;
    private readonly currencyCode: string;
    private readonly currencySymbolPlaceholderRegExp = new RegExp('{{prependCurrencySymbol}}', 'g');
    private readonly currencyCodePlaceholderRegExp = new RegExp('{{currency}}', 'g');

    constructor(
        private currencyConfig: CurrencyConfig,
        private userService: UserService,
    ) {
        this.currencyCode = this.userService.currency;
        this.isCurrencySymbolEnabled = this.currencyConfig.currencySymbolDisplayList.includes(this.userService.currency);
    }

    updateCurrencyPlaceholders(message: string): string {
        if (!this.currencyCode) {
            return message;
        }

        if (!this.isCurrencySymbolEnabled || !this.currencySymbolPlaceholderRegExp.test(message)) {
            return message.replace(this.currencyCodePlaceholderRegExp, this.currencyCode).replace(this.currencySymbolPlaceholderRegExp, '');
        }

        const currencySymbol = getCurrencySymbol(this.currencyCode, 'narrow');

        return message.replace(this.currencySymbolPlaceholderRegExp, currencySymbol).replace(this.currencyCodePlaceholderRegExp, '');
    }
}
